import { InputCaptionTheme } from '@/components/InputCaption/theme';
import { GenericSlotFactory } from 'base/components/GenericSlot';

const $ = GenericSlotFactory({ theme: InputCaptionTheme });

const Base = $({ as: 'div' });

export const InputCaption = Base;
